export type BankruptcyChapter = "generic" | "chapter_7" | "chapter_11";

export const BANKRUPTCY_CHAPTER_LABEL: Record<BankruptcyChapter, string> = {
  generic: "Generic",
  chapter_7: "Chapter 7",
  chapter_11: "Chapter 11",
};

export type BankruptcyEventType = "informational" | "shareholder_options";

export const BANKRUPTCY_EVENT_TYPE_LABEL: Record<BankruptcyEventType, string> =
  {
    informational: "Informational",
    shareholder_options: "Shareholder Options",
  };
